export default {
  groupName: 'audible',
  appName: 'Audible',
  baseRoute: '/dashboard/audible',
  label: 'Audible Dashboard',
  home: '/slicer',
  image: 'audible.png',
  description: 'Audible Advertising Dashboard'
}



// WEBPACK FOOTER //
// ./src/app/configuration/Audible/config/main.js